import React, { useEffect, useState } from 'react';
import { getChartsShowCount, mathFormat } from '../../utils';
import { formatter } from '../../components/ChartCommon/formatter';
import EChartCommon from '../../components/EChartCommon';
import { getLocale, useIntl } from 'umi';
import { setIntervalValue } from '../../utils/chart';
export default function MentionsChart(props: any) {
  const { mentionsList, leftTitle, rightTitle } = props;

  const [option, setOption] = useState({});

  const { formatMessage } = useIntl();

  useEffect(() => {
    const curOption = {
      tooltip: {
        formatter: (params: any) => {
          let gameName: any;
          let total: any;
          if (params.length > 0) {
            gameName = params[0].axisValue;
            total = mentionsList[params[0]?.dataIndex]?.mentions;
          }

          const records = [
            {
              type: formatMessage({ id: 'Mentions' }),
              score: mathFormat(total),
            },
          ];

          for (let index = 0; index < params.length; index++) {
            const element = params[index];
            const name = element.seriesName;

            if (name === 'total总数') continue;

            let rate = 0;
            const metionIndex = mentionsList.findIndex(
              (v, i) => v.entityName === element.axisValue,
            );
            switch (element.seriesName) {
              case formatMessage({ id: 'Sentiment AVG' }):
                break;
              case formatMessage({ id: 'Positive' }):
                rate = mentionsList[metionIndex]?.positiveRate;
                break;
              case formatMessage({ id: 'Neutral' }):
                rate = mentionsList[metionIndex]?.neutralRate;
                break;
              case formatMessage({ id: 'Negative' }):
                rate = mentionsList[metionIndex]?.negativeRate;
                break;
            }

            let scoreText: Number | string = '';
            if (rate) {
              scoreText = mathFormat(element.value);
            } else {
              if (typeof element.value === 'number') {
                scoreText = element.value?.toFixed(2);
              } else {
                scoreText = Number(element.value).toFixed(2);
              }
            }

            records.push({
              type: `<span class="chart-common-formatter-marker">${params[index].marker}</span>&nbsp;${name}`,
              score: `${scoreText}${
                rate ? '(' + Math.round(rate * 100) + '%)' : ''
              }`,
            });
          }

          return formatter({
            title: gameName,

            tables: [
              {
                showHeader: false,
                records,
                columns: [
                  {
                    key: 'type',
                  },
                  {
                    key: 'score',
                    align: 'right',
                    weight: 'bold',
                  },
                ],
              },
            ],
          });
        },
      },
      grid: {
        top: '20px',
      },
      legend: {
        data: ['Sentiment AVG', 'Positive', 'Neutral', 'Negative'].map((item) =>
          formatMessage({ id: item }),
        ),
      },
      xAxis: {
        data: [],
      },
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: (value: any) => getChartsShowCount(value),
          },
          splitNumber: 5,
          min: 0,
        },
        {
          type: 'value',
          max: 5,
          min: 0,
          splitNumber: 5,
        },
      ],
      series: [
        {
          name: 'total总数',
          type: 'bar',
          barMaxWidth: '70px', // 柱子宽度同实体柱子，否则会错位
          barGap: '-100%', // 左移100%，stack不再与需堆叠的柱子在一列
          label: {
            normal: {
              show: true,
              position: 'top', // 位置设为top
              formatter: (c: any) => {
                return mathFormat(mentionsList[c?.dataIndex].mentions);
              },
              textStyle: { color: '#444' },
            },
          },
          itemStyle: {
            normal: {
              color: 'rgba(128, 128, 128, 0)', // 为透明
            },
          },
          data: [],
        },
        {
          name: formatMessage({ id: 'Sentiment AVG' }),
          type: 'line',
          yAxisIndex: 1,
          lineStyle: {
            color: '#376AE7',
          },
          data: [],
        },
        {
          name: formatMessage({ id: 'Positive' }),
          type: 'bar',
          stack: '1',
          yAxisIndex: 0,
          data: [],
          itemStyle: {
            color: '#69D19C',
          },
          barMaxWidth: '70px',
        },
        {
          name: formatMessage({ id: 'Neutral' }),
          type: 'bar',
          stack: '1',
          yAxisIndex: 0,
          data: [],
          itemStyle: {
            color: '#6E7794',
          },
          barMaxWidth: '70px',
        },
        {
          name: formatMessage({ id: 'Negative' }),
          type: 'bar',
          stack: '1',
          yAxisIndex: 0,
          data: [],
          itemStyle: {
            color: '#F17C86',
          },
          barMaxWidth: '70px',
        },
      ],
    };

    if (mentionsList) {
      const sentimentAvg: any = [];
      const sentimentNegative: any = [];
      const sentimentNeutraul: any = [];
      const sentimentPositive: any = [];
      const entityName: any = [];

      mentionsList.map((item: any) => {
        sentimentAvg.push(item.sentiment?.toFixed(2));
        sentimentNegative.push(item.negativeNum);
        sentimentNeutraul.push(item.neutralNum);
        sentimentPositive.push(item.positiveNum);
        entityName.push(item.entityName);
      });
      curOption.xAxis.data = entityName;
      curOption.series[2].data = sentimentPositive;
      curOption.series[3].data = sentimentNeutraul;
      curOption.series[4].data = sentimentNegative;
      curOption.series[1].data = sentimentAvg;

      // 固定8个以下，都可以展示出来
      curOption.series[0].data = mentionsList.map(
        (item: any) => item?.mentions,
      );
      setIntervalValue(curOption.series[0].data, curOption.yAxis[0]);
    }

    setOption(curOption);
  }, [mentionsList, getLocale()]);

  return (
    <EChartCommon
      options={option}
      leftTitle={leftTitle}
      rightTitle={rightTitle}
      optionsProps={{ type: 'bar', xAxisLabelInterval: 0 }}
    />
  );
}
